import axios from 'axios';
import Constants from 'config/constants';
import { getToken } from "../auth/authenticate";
const { ApiEndpoint } = Constants.ApiConstants;

export const AxiosInstance = axios.create({
  baseURL: ApiEndpoint.BASE_URL,
  timeout: 5000,
});

AxiosInstance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = "Bearer " + getToken();
    config.headers["Content-Type"] = "application/json";

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  response => response.data,

  error => {
    handleError(error);

    // added with consultations service
    // return Promise.reject(error);
  }
);

// Handle common errors
const handleError = error => {
  if (error.response) {
    if (error.response.status === 400) {
      console.log('Error code 400');
    } else if (error.response.status === 401) {
      console.log('Error code 401 ');
    } else if (error.response.status === 500) {
      console.log('Error code 500 ');
    } else {
      console.log('Error ');
    }
  } else {
    console.log('Network Error ');
  }
};

export const api = async (route, method, params, data, checkNetwork = true) => {
  let configObj = {
    url: route,
    method: method,
  };

  if (params) {
    configObj = { ...configObj, params: params };
  } else if (data) {
    configObj = { ...configObj, data: data };
  }

  return await AxiosInstance(configObj)
    .then(response => response)
    .catch(error => error);
};
